const React = require("react");
const RootElement = require("./src/components/root-element").default;

exports.wrapRootElement = ({ element }) =>
  React.createElement(RootElement, null, element);

exports.onClientEntry = function onClientEntry() {
  // Load Sentry as an async chunk instead of the critical path. The
  // @sentry/gatsby plugin would otherwise inject the SDK into every webpack
  // entry (baking it into the eager app chunk), so its config lives at
  // src/sentry.client.js — outside the plugin's ./sentry.config.js lookup —
  // and is initialised here.
  if (process.env.NODE_ENV === "production") {
    import("./src/sentry.client").catch(() => {});
  }

  // Defer scriptwrapper until after the browser is idle so third-party
  // analytics (Yandex Metrica, etc.) fire when the DOM is fully ready.
  // if (document.readyState === "complete") {
  //   scheduleScriptwrapper();
  // } else {
  //   window.addEventListener("load", scheduleScriptwrapper, { once: true });
  // }

  window.addEventListener("unhandledrejection", ({ reason }) => {
    const isChunkError =
      reason &&
      (reason.name === "ChunkLoadError" ||
        /Loading chunk \d+ failed/i.test(reason.message || "") ||
        /page resources for .* not found/i.test(reason.message || ""));

    if (isChunkError) {
      // Prevent infinite reload loops: only reload once every 30 seconds.
      const RELOAD_KEY = "__chunkErrReload";
      const lastReload = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
      if (Date.now() - lastReload > 30000) {
        sessionStorage.setItem(RELOAD_KEY, Date.now().toString());
        window.location.reload();
      }
    }
  });
};
